import styled from '@emotion/styled';
import { ProductQueryProductItem } from '~/lib/data-contract/auto-generated/shop-api-model';
import { hazardSymbols } from '../utils/hazardSymbols';

type Props = {
    product: ProductQueryProductItem;
    onClick: (event: React.MouseEvent) => void;
};

export default function HazardSymbols({ product, onClick }: Props) {
    if (!product.itemHazardSymbols?.length) {
        return null;
    }

    return (
        <Button onClick={onClick}>
            <Symbols>
                {product.itemHazardSymbols.map((symbol, index) => {
                    const Icon = hazardSymbols[symbol as keyof typeof hazardSymbols];
                    return (
                        <Symbol key={index}>
                            <Icon />
                        </Symbol>
                    );
                })}
            </Symbols>
        </Button>
    );
}

const Button = styled.button(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
}));

const Symbols = styled.ul(({ theme }) => ({
    display: 'flex',
    gap: theme.space[2],
}));

const Symbol = styled.li(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',

    svg: {
        height: theme.space[6],
        width: theme.space[6],
    },
}));
